import { render, staticRenderFns } from "./OnboardingStepDate.vue?vue&type=template&id=58e64f16"
import script from "./OnboardingStepDate.vue?vue&type=script&lang=js"
export * from "./OnboardingStepDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports